
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Otevřete nabídku prohlížeče`,
's182ab2d6c997515f': `Přidejte jej na plochu pro rozšířené využití a snadný přístup.`,
's1b9047d53d9f9d22': `2) Stiskněte tlačítko Sdílet na navigačním panelu`,
's2d90afa5dcca2c0e': `3) Projděte dolů k "Přidat na plochu"`,
's37a9e8aec5713460': `Vice`,
's4593f304dac8848c': `2) Klepněte na "Přidat na plochu"`,
's54cfbb14f46396d4': `1) Otevřete v hlavním prohlížeči`,
's6196153c4b0c1ea0': `Nainstalovat`,
's922329d6f6213590': `Přidat do Docku`,
'sa5ef80b4bb9b39f8': `Méně`,
'sa7551383d1897fcc': `2) Stiskněte Přidat do Docku`,
'sba52286c21552a4e': `Nainstalujte si jej na své zařízení pro rozšířené využití a snadný přístup.`,
'sc79fd7641eb9a975': `Skrýt instrukce`,
'scdaf4bbff76674c8': `Přidat na plochu`,
'se740f75b95a51807': `Přidejte jej do svého Docku pro rozšířené využití a snadný přístup.`,
'sfea652f6580ff086': `Tento web má funkce aplikace.`,
    };
  